import React from 'react';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby';
import ButtonComponent from '../../utils/ButtonComponent';
import LinkComponent from '../../utils/linkComponent';

const NewsletterSignupStyled = styled.div`
	background: var(--primary); /* Use primary color as background */
	padding: 3rem 0;
	margin: 0;
	color: #f3f4f6; /* Light gray text */
	text-align: center;

	.newsletter-title {
		font-size: 2rem;
		font-weight: 700;
		margin-bottom: 1rem;
		color: #f3f4f6;
		font-family: var(--hero_title_font_family);
	}

	.newsletter-description {
		font-size: 1.1rem;
		margin-bottom: 2rem;
		color: #d1d5db;
		font-family: var(--primary_font_family);
	}

	.form-container {
		max-width: 600px;
		margin: 0 auto;
	}

	.btnContainer {
		display: flex;
		justify-content: center;
		margin-top: 1rem;
	}

	/* Override button styling to use secondary_1 color */
	.btnContainer .btn {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
	}

	.btnContainer .btn:hover {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		opacity: 0.9;
	}

	.btnContainer .btn:focus {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		box-shadow: 0 0 0 0.2rem rgba(var(--secondary_1-rgb), 0.25) !important;
	}

	@media (max-width: 768px) {
		padding: 2rem 1rem;

		.newsletter-title {
			font-size: 1.5rem;
		}

		.newsletter-description {
			font-size: 1rem;
		}
	}
`;

const NewsletterSignup = () => {
	// Get strapiAsset data for button shape
	const strapiAssetData = useStaticQuery(graphql`
		query NewsletterStrapiAsset {
			strapiAsset {
				button_shape
			}
		}
	`);

	// Get the external newsletter URL from environment variable
	const newsletterUrl =
		process.env.GATSBY_NEWSLETTER_URL || 'https://example.com/newsletter';

	return (
		<NewsletterSignupStyled>
			<Container>
				<div className='form-container'>
					<h2 className='newsletter-title'>Newsletter Sign Up</h2>
					<p className='newsletter-description'>
						Stay informed with WIL updates, events & insights
					</p>

					<div className='btnContainer'>
						<LinkComponent
							to={newsletterUrl}
							onClick={() => {
								// Track analytics if available
								if (typeof window !== 'undefined' && window.analytics) {
									window.analytics.track('Newsletter Signup Clicked', {
										title: 'Newsletter Signup Panel',
										action: 'Clicked',
										location: window.location.href,
										link: newsletterUrl,
										page: window.location.pathname,
									});
								}
							}}
						>
							<ButtonComponent
								analyticsTrackTitle='Newsletter Signup'
								analyticsTitle='Newsletter Signup Panel'
								windowLocationHref={
									typeof window !== 'undefined' ? window.location.href : ''
								}
								buttonName='SUBSCRIBE'
								iconVisible={false}
								buttonShape={strapiAssetData.strapiAsset?.button_shape}
							/>
						</LinkComponent>
					</div>
				</div>
			</Container>
		</NewsletterSignupStyled>
	);
};

export default NewsletterSignup;
